<div class="sidebar-container">
    <h2 class="sidebar-header">Utilities</h2>
    <mat-nav-list class="utility-app-list" [@loadListAnimation]="utilityService.utilities.length">
      @for (utility of utilityService.utilities; track utility.title) {
        <mat-card class="utility-item-card" [routerLink]="['/utilities', utility.route]" routerLinkActive="active">
            <div class="utility-item-card-content">
                <div class="utility-icon-container">
                    <mat-icon class="utility-icon">{{utility.icon}}</mat-icon>
                </div>
                <div class="utility-text-container">
                    <mat-card-title class="utility-title">{{utility.title}}</mat-card-title>
                </div>
            </div>
        </mat-card>
      }
    </mat-nav-list>
  </div>